import axios from 'axios';

const actions = {
    async editProfile({ commit }, user) {
        const response = await axios.put('/api/user/profile', user)
        commit('setProfile', response.data)
        return Promise.resolve();
    },
}

const mutations = {
    setProfile: (state, profile) => (state.profile = profile)
}

export default {
    mutations,
    actions,
}